export enum CONTRACT_STATUS {
  ACTIVE = "active",
  INACTIVE = "no_contract",
  EXPIRED = "expired",
  CANCELLED = "cancelled",
}

export enum ROLES {
  GENERAL = "一般",
  ADMIN = "管理者",
  CONTACT = "連絡先",
}

export enum USER_TYPE {
  INTERNAL = 1,
  EXTERNAL = 2,
  KEYCLOAK_USER = 3,
}

export enum USER_TYPE_STRING {
  INTERNAL = "internal",
  EXTERNAL = "external",
  KEYCLOAK_USER = "keycloak_user",
}

export enum METHOD_TYPE {
  DELETE = "delete",
  CREATE = "create",
  UPDATE = "update",
}

export enum LOGIN_STATES {
  START = "start",
  LOGGING_IN = "logging_in",
  LOGGED_IN = "logged_in",
  LOGGING_OUT = "logging_out",
  PREVIOUS_STATE = "previousState",
  CURRENT_STATE = "logInState",
}

export enum APP_NAMES {
  KAKELY = "KAKELY",
  YOBELY = "YOBELY",
  WORKJOY = "WorkJoy",
}

export enum POLLING_MESSAGES {
  PROCESSING = "still processing",
  COMPLETED = "processing completed",
  FAILED = "processing failed",
}

export enum KEYCLOAK_EVENTS {
  AUTH_SUCCESS = "onAuthSuccess",
  AUTH_LOGOUT = "onAuthLogout",
  AUTH_REFRESH_SUCCESS = "onAuthRefreshSuccess",
  ON_TOKEN_EXPIRED = "onTokenExpired",
}

export enum DUPLICATE_TYPES {
  PERSONAL_TEL = "個人電話番号",
  EMAIL = "メールアドレス",
  FULL_NAME = "氏名",
}
